module.exports = __webpack_public_path__ + "img/CheyYannaiPicture.8f14aad9.jpg";